module.exports = __webpack_public_path__ + "img/171.22dc750d.jpg";